import { render, staticRenderFns } from "./Sampling.vue?vue&type=template&id=955d13c0"
import script from "./Sampling.vue?vue&type=script&lang=js"
export * from "./Sampling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports